import { BRANCO, PERIGO, TEXTO, BORDA_FORTE, RAIO, FUNDO_SUAVE, ACAO } from "../tema";
import Icone from "./Icone";

// Botão do painel.
//
// Três variantes e dois tamanhos, e nada além disso. A tentação é criar uma
// variante por tela; o resultado é o que o painel tinha, com a mesma ação
// aparecendo como pílula em um lugar e como link em outro.
//
// `discreto` é a ação secundária dentro de uma linha de lista, do tipo
// "editar": precisa existir, não precisa disputar atenção.
export default function Btn({
  onClick, disabled, children, style = {},
  variant = "primary", tamanho = "md", titulo, icone, type,
}) {
  const alturas = {
    sm: { padding: "7px 13px", fontSize: 12.5 },
    md: { padding: "11px 20px", fontSize: 14 },
  };
  const base = {
    border: "none", borderRadius: RAIO.md, fontWeight: 700,
    fontFamily: "inherit", lineHeight: 1.2,
    display: "inline-flex", alignItems: "center", justifyContent: "center",
    gap: 8, whiteSpace: "nowrap",
    cursor: disabled ? "not-allowed" : "pointer",
    transition: "filter 0.15s, background 0.15s, box-shadow 0.15s",
    filter: disabled ? "none" : undefined,
    ...alturas[tamanho],
  };
  const variants = {
    primary: {
      background: disabled ? "#9CA3AF" : ACAO, color: BRANCO,
      boxShadow: disabled ? "none" : "0 1px 2px rgba(29, 99, 232, 0.35)",
    },
    secondary: { background: "transparent", color: ACAO, border: `1.5px solid ${ACAO}` },
    danger: { background: disabled ? "#9CA3AF" : PERIGO, color: BRANCO },
    discreto: {
      background: FUNDO_SUAVE, color: TEXTO, border: `1px solid ${BORDA_FORTE}`, fontWeight: 600,
    },
  };
  return (
    <button type={type || "button"} onClick={onClick} disabled={disabled} title={titulo}
      style={{ ...base, ...variants[variant], ...style }}>
      {icone && <Icone nome={icone} tamanho={tamanho === "sm" ? 15 : 17} />}
      {children}
    </button>
  );
}
